var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailIconFillAble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1154 11.4959L16.1911 7.09682C15.9627 6.96773 15.6946 6.96773 15.4662 7.09682L7.56171 11.4959C6.69778 11.9726 6.15161 12.8961 6.15161 13.8792V20.6516C6.15161 22.161 7.37303 23.3824 8.88243 23.3824H22.7848C24.2942 23.3824 25.5156 22.161 25.5156 20.6516V13.8792C25.5156 12.8862 24.9794 11.9726 24.1154 11.4959ZM15.8336 8.59629L23.2416 12.7074L16.4394 16.4809C16.062 16.6894 15.6151 16.6894 15.2378 16.4809L8.43557 12.7074L15.8435 8.59629H15.8336ZM22.7848 21.8929H8.88243C8.19724 21.8929 7.64115 21.3368 7.64115 20.6516V13.9686L14.503 17.7818C14.92 18.0102 15.3768 18.1293 15.8336 18.1293C16.2904 18.1293 16.7472 18.0102 17.1643 17.7818L24.0261 13.9686V20.6516C24.0261 21.3368 23.47 21.8929 22.7848 21.8929Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconFillAble);
export default __webpack_public_path__ + "static/media/emailIconFillAble.b01d24ca.svg";
export { ForwardRef as ReactComponent };